module.exports = "<label class=\"btn btn-outline-primary btn-import ml-2\" [ladda]=\"isUploading\">Import\n    <input *ngIf=\"!isUploading\" type=\"file\" (change)=\"fileUpload($event)\">\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/import-button/import-button.component.html
// module id = ./src/app/components/import-button/import-button.component.html
// module chunks = main